import { combineReducers } from 'redux'
import _ from 'lodash'

import snapshot from './snapshot'

import {
  FETCH_ITEMS,
  FETCH_ITEMS_SUCCESS,
  FETCH_ITEMS_FAIL,
  FETCH_ITEM,
  FETCH_ITEM_SUCCESS,
  FETCH_ITEM_FAIL,
  FETCH_ITEM_STATUS,
  FETCH_ITEM_STATUS_SUCCESS,
  FETCH_ITEM_STATUS_FAIL,
  FETCH_ITEMS_STATUS,
  FETCH_ITEMS_STATUS_SUCCESS,
  FETCH_ITEMS_STATUS_FAIL,
  FETCH_ITEM_SURFACES,
  FETCH_ITEM_SURFACES_SUCCESS,
  FETCH_ITEM_SURFACES_FAIL,
  FETCH_ITEM_SURFACE,
  FETCH_ITEM_SURFACE_SUCCESS,
  FETCH_ITEM_SURFACE_FAIL,
  EXPAND,
  COLLAPSE,
  SET_EXPANDED,
  SET_SYNC_HINT,
  SYNC_SURFACES_SUCCESS,
  SAVE_FILTER,
  FETCH_FILTER,
  FETCH_FILTER_SUCCESS,
  SAVE_SORT,
  FETCH_SORT,
  FETCH_SORT_SUCCESS,
  NEXT_PAGE,
  SYNC_MEDIA_PLAYER,
  SYNC_MEDIA_PLAYER_FAIL,
  SYNC_MEDIA_PLAYER_SUCCESS,
  BULK_SYNC,
  BULK_SYNC_FAIL,
  BULK_SYNC_SUCCESS
} from 'react-redux/actions/media-player'

import { RESET } from 'react-redux/actions/app'

const initialListState = {
  // mediaPlayers
  items: {},
  // view
  list: [],

  fetchingList: false,
  filter: {
    initialized: false,
    expression: "",
    fetching: false
  },
  pagination: {
    reachedEnd: false,
    page: 0,
    maxResults: 3,
  },
  query: {
    filter: null,
    page: null,
    sort_by_field: null,
    reverse_order: null,
    max_results: null
  },
  pendingQuery: null,
  sort: {
    initialized: false,
    field: "name",
    fetching: false,
    reverse: {
      name: false,
      description: false
    }
  },

  bulkSync: {
    pending: 0
  },

  status: {},
  syncHint: {},
  syncing: {},
  // channels
  surfaces: {}, // virtual, {mediaplayerId:{surfaceId: ...}}
  // view
  expanded: {}
}

const list = (state = initialListState, action) => {
  switch (action.type) {
    case RESET: {
      return _.cloneDeep(initialListState)
    }
    case FETCH_ITEMS: {
      const {filter, page, sort_by_field, reverse_order, max_results} = action.payload
      const pendingQuery =  {
        filter,
        page,
        sort_by_field,
        reverse_order,
        max_results
      }
      return Object.assign(
        {},
        state,
        {
          pendingQuery,
          fetchingList: true
        }
      )
    }
    case FETCH_ITEMS_SUCCESS: {
      const {query, pendingQuery, pagination} = state
      let items = Object.assign({}, state.items)
      let list = []
      action.payload.forEach((item)=>{
        const uid = item.id
        items[uid] = item.data
        list.push(uid)
      })
      const reachedEnd = (list.length < state.pendingQuery.max_results-1)
      const clear = query.filter !== pendingQuery.filter
        || query.sort_by_field !== pendingQuery.sort_by_field
        || query.reverse_order !== pendingQuery.reverse_order
      return Object.assign(
        {},
        state,
        {
          items,
          query: Object.assign({}, pendingQuery),
          pendingQuery: null,
          list: clear ? list: state.list.concat(list),
          pagination: Object.assign(
            {},
            pagination,
            {
              reachedEnd,
              page: pendingQuery.page
            }
          ),
          fetchingList: false
        }
      )
    }
    case FETCH_ITEMS_FAIL: {
      const { pagination, pendingQuery } = state
      return Object.assign(
        {},
        state,
        {
          list: [],
          query: Object.assign({}, pendingQuery),
          pendingQuery: null,
          fetchingList: false,
          pagination: Object.assign(
            {},
            pagination,
            {
              reachedEnd: true,
              page: 0
            }
          ),
        }
      )
    }
    case NEXT_PAGE: {
      if (state.reachedEnd || state.fetchingList) return state
      let pagination = Object.assign({}, state.pagination)
      pagination.page++
      return Object.assign({}, state, {pagination})
    }
    case FETCH_ITEM: {
      return state
    }
    case FETCH_ITEM_SUCCESS: {
      let items = Object.assign({}, state.items)
      items[action.context.payload.uid] = action.payload
      return Object.assign({}, state, { items })
    }
    case FETCH_ITEM_FAIL: {
      return state
    }
    case FETCH_ITEMS_STATUS: {
      return state
    }
    case FETCH_ITEMS_STATUS_SUCCESS: {
      return Object.assign({}, state, {status: action.payload})
    }
    case FETCH_ITEMS_STATUS_FAIL: {
      return state
    }
    case FETCH_ITEM_STATUS: {
      return state
    }
    case FETCH_ITEM_STATUS_SUCCESS: {
      let items = Object.assign({}, state.items)
      items[action.context.payload.uid] = Object.assign({}, items[action.context.payload.uid], action.payload)
      return Object.assign({}, state, { items })
    }
    case FETCH_ITEM_STATUS_FAIL: {
      return state
    }
    case FETCH_ITEM_SURFACES: {
      return state
    }
    case FETCH_ITEM_SURFACES_SUCCESS: {
      let surfaces = _.cloneDeep(state.surfaces)
      surfaces[action.context.payload.uid] = action.payload
      return Object.assign({}, state, { surfaces })
    }
    case FETCH_ITEM_SURFACES_FAIL: {
      return state
    }
    case FETCH_ITEM_SURFACE: {
      return state
    }
    case FETCH_ITEM_SURFACE_SUCCESS: {
      let surfaces = _.cloneDeep(state.surfaces)
      if(!surfaces[action.context.payload.mediaPlayerId]) surfaces[action.context.payload.mediaPlayerId] = {}
      surfaces[action.context.payload.mediaPlayerId][action.context.payload.surfaceId] = action.payload
      return Object.assign({}, state, { surfaces })
    }
    case FETCH_ITEM_SURFACE_FAIL: {
      return state
    }
    case SAVE_FILTER: {
      const filter = Object.assign(
        {},
        state.filter,
        { expression: action.payload}
      )
      return Object.assign({}, state, { filter } )
    }
    case FETCH_FILTER: {
      const filter = Object.assign(
        {},
        state.filter,
        { fetching: true }
      )
      return Object.assign({}, state, { filter })
    }
    case FETCH_FILTER_SUCCESS: {
      const filter = Object.assign(
        {},
        state.filter,
        {
          expression: action.payload || "",
          fetching: false,
          initialized: true
        }
      )
      return Object.assign(
        {},
        state,
        {
          filter
        }
      )
    }
    case SAVE_SORT: {
      const {field, reverse} = action.payload
      const sort = Object.assign(
        {},
        state.sort,
        { field, reverse }
      )
      return Object.assign({}, state, { sort } )
    }
    case FETCH_SORT: {
      const sort = Object.assign(
        {},
        state.sort,
        { fetching: true }
      )
      return Object.assign({}, state, { sort })
    }
    case FETCH_SORT_SUCCESS: {
      let sort = Object.assign(
        {},
        state.sort,
        {
          fetching: false,
          initialized: true
        }
      )
      if (action.payload && action.payload.field)
        sort.field = action.payload.field
      if (action.payload && action.payload.reverse)
        sort.reverse = action.payload.reverse
      return Object.assign(
        {},
        state,
        { sort }
      )
    }
    case EXPAND: {
      let expanded = _.clone(state.expanded)
      expanded[action.uid] = true
      return Object.assign({}, state, { expanded })
    }
    case COLLAPSE: {
      let expanded = _.clone(state.expanded)
      delete expanded[action.uid]
      return Object.assign({}, state, { expanded })
    }
    case SET_EXPANDED: {
      return Object.assign({}, state, { expanded: action.expanded })
    }
    case SYNC_MEDIA_PLAYER: {
      let syncing = _.cloneDeep(state.syncing)
      syncing[action.payload.uid] = true
      return Object.assign({}, state, { syncing })
    }
    case SYNC_MEDIA_PLAYER_FAIL: {
      let syncing = _.cloneDeep(state.syncing)
      delete syncing[action.context.payload.uid]
      return Object.assign({}, state, { syncing })
    }
    case SYNC_MEDIA_PLAYER_SUCCESS: {
      let syncing = _.cloneDeep(state.syncing)
      delete syncing[action.context.payload.uid]
      return Object.assign({}, state, { syncing })
    }
    case SYNC_SURFACES_SUCCESS: {
      let surfaces = _.cloneDeep(state.surfaces)
      surfaces[action.context.payload.uid] = action.payload
      return Object.assign({}, state, { surfaces })
    }
    case BULK_SYNC: {
      const bulkSync = _.cloneDeep(state.bulkSync)
      bulkSync.pending++
      return Object.assign({}, state, { bulkSync })
    }
    case BULK_SYNC_FAIL: {
      const bulkSync = _.cloneDeep(state.bulkSync)
      bulkSync.pending--
      return Object.assign({}, state, { bulkSync })
    }
    case BULK_SYNC_SUCCESS: {
      const bulkSync = _.cloneDeep(state.bulkSync)
      bulkSync.pending--
      return Object.assign({}, state, { bulkSync })
    }
    default:
      return state
  }
}

export default combineReducers({
  list,
  snapshot
})



// WEBPACK FOOTER //
// ./src/app/react-redux/reducers/media-player.js